import { render, staticRenderFns } from "./floorIntroduce.vue?vue&type=template&id=1380292e&scoped=true&"
import script from "./floorIntroduce.vue?vue&type=script&lang=js&"
export * from "./floorIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./floorIntroduce.vue?vue&type=style&index=0&id=1380292e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380292e",
  null
  
)

export default component.exports